import type { Holder, HoldersInfo } from "epsm-api-types/models";
import type { IReadAllParams } from "@/services/RequestParams";
import { useGetData } from "../../../hooks/useGetData";
import { HoldersInfoService } from "./services/HoldersInfoService";
import { HoldersService } from "./services/HoldersService";

export interface Options {
	ticker: string;
	params?: IReadAllParams;
}

export class UseData {
	private constructor(
		private holdersInfoService: HoldersInfoService,
		private holdersService: HoldersService,
	) {}

	private static instance: UseData;

	static create() {
		if (!UseData.instance) {
			UseData.instance = new UseData(
				HoldersInfoService.create(),
				HoldersService.create(),
			);
		}
		return UseData.instance;
	}

	getHoldersInfoData = async ({
		ticker,
		params,
	}: Options): Promise<HoldersInfo | null> => {
		if (!ticker) {
			return null;
		}
		const data = await this.holdersInfoService.getData(ticker, params ?? {});
		return data ?? null;
	};

	getHolderData = async ({
		ticker,
		params,
	}: Options): Promise<Holder[] | null> => {
		if (!ticker) {
			return null;
		}

		const data = await this.holdersService.getData(ticker, params ?? {});

		return data.data ?? [];
	};

	getTopHoldersData = async ({ ticker }: Options): Promise<Holder[] | null> => {
		if (!ticker) {
			return null;
		}

		const data = await this.holdersService.getTopHolders(ticker);

		return data.data ?? [];
	};

	useGetHoldersInfoData = () =>
		useGetData<HoldersInfo | null, Options>(this.getHoldersInfoData);

	useGetHolderData = () =>
		useGetData<Holder[] | null, Options>(this.getHolderData);

	useGetTopHoldersData = () =>
		useGetData<Holder[] | null, Options>(this.getTopHoldersData);
}
